// Strings for the world 'attic': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Bedstemors loft',
    levels: {
      'click': { title: 'Klik' },
      'uphill': { title: 'Op ad bakken' },
      'hold-and-release': { title: 'Hold og slip' },
      'far-away': { title: 'Langt væk' },
      'through-the-book': { title: 'Gennem bogen' },
      'wooden-ball': { title: 'Træ-kuglen' },
      'swing': { title: 'Sving' },
      'button': { title: 'Knappen' },
      'onto-the-suitcase': { title: 'Op på kufferten' },
      'stopper': { title: 'Stopperen' },
      'iron': { title: 'Strygejernet' },
      'fish-it-up': { title: 'Fisk den op' },
      'stairs': { title: 'Trappen' },
      'tip-and-click': { title: 'Vip og klik' },
      'master': { title: 'Mester' },
    },
  },
  en: {
    name: 'Granny\'s attic',
    levels: {
      'click': { title: 'Click' },
      'uphill': { title: 'Up the hill' },
      'hold-and-release': { title: 'Hold and let go' },
      'far-away': { title: 'Far away' },
      'through-the-book': { title: 'Through the book' },
      'wooden-ball': { title: 'The wooden ball' },
      'swing': { title: 'Swing' },
      'button': { title: 'The button' },
      'onto-the-suitcase': { title: 'Onto the suitcase' },
      'stopper': { title: 'The stopper' },
      'iron': { title: 'The iron' },
      'fish-it-up': { title: 'Fish it out' },
      'stairs': { title: 'The stairs' },
      'tip-and-click': { title: 'Tip and click' },
      'master': { title: 'Master' },
    },
  },
});
